import { Routes } from '@angular/router';
import {
  GeaMesAccessDeniedComponent,
  GeaMesCognitoAuthGuard,
  GeaMesLoginComponent,
  GeaMesLogoutComponent
} from '@gea-mes/cognito';

import { ObjectListComponent } from './object-list/object-list.component';
import { TaskListComponent } from './task-list/task-list.component';
import { AdminComponent } from './admin/components/admin/admin.component';
import { DashboardComponent } from './dashboard/components/dashboard/dashboard.component';
import { CompletedOverviewComponent } from './dashboard/components/completed-overview/completed-overview.component';
import { EquipmentOverviewComponent } from './dashboard/components/equipment-overview/equipment-overview.component';
import { EquipmentIssueDetailsComponent } from './dashboard/components/equipment-issue-details/equipment-issue-details.component';
import { EquipmentStatusDetailsComponent } from './dashboard/components/equipment-status-details/equipment-status-details.component';
import { ShiftListComponent } from './shift-list/shift-list.component';
import { CurrentOverviewStatusComponent } from './dashboard/components/current-overview-status/current-overview-status.component';
import { ValidatorStatusComponent } from './admin/components/validator-status/validator-status.component';
import { ValidatorResultsComponent } from './admin/components/validator-results/validator-results.component';
import { SectionOverviewComponent } from './dashboard/components/section-overview/section-overview.component';
import { AdminTaskListComponent } from './admin/components/admin-task-list/admin-task-list.component';

export const routes: Routes = [
  { path: 'login', component: GeaMesLoginComponent },
  { path: 'logout', component: GeaMesLogoutComponent },
  { path: 'accessdenied', component: GeaMesAccessDeniedComponent },
  {
    path: '',
    canActivate: [GeaMesCognitoAuthGuard],
    children: [
      { path: '', redirectTo: '/home', pathMatch: 'full' },
      { path: 'home', component: ObjectListComponent },
      { path: 'home/:plant', component: ObjectListComponent },
      { path: 'home/:plant/:section', component: ObjectListComponent },
      { path: 'home/:plant/:section/:subsection', component: ObjectListComponent },

      { path: 'admin', component: AdminComponent },
      { path: 'admin/:plant', component: AdminComponent },
      { path: 'admin/tasklist/:plant/:site/:environment/:object', component: AdminTaskListComponent },
      { path: 'admin/tasklist/validator', component: ValidatorStatusComponent },
      { path: 'admin/tasklist/validator/results/:tasktype', component: ValidatorResultsComponent },

      { path: 'dashboard', component: DashboardComponent },
      { path: 'dashboard/overview-metrics', component: CompletedOverviewComponent },
      { path: 'dashboard/section-overview/:site', component: SectionOverviewComponent },
      { path: 'dashboard/equipment-overview/:site/:section/:subSection', component: EquipmentOverviewComponent },
      { path: 'dashboard/equipment-overview/:site/:section', component: EquipmentOverviewComponent },
      { path: 'dashboard/equipment-overview/:site', component: EquipmentOverviewComponent },
      { path: 'dashboard/equipment-issues/:site/:object/:tasktype', component: EquipmentIssueDetailsComponent },
      { path: 'dashboard/equipment-status-details/:site/:env/:object', component: EquipmentStatusDetailsComponent },

      { path: 'objectlist', component: ObjectListComponent },
      { path: 'tasklist/:site/:environment/:object', component: ShiftListComponent },
      { path: 'tasklist/:site/:environment/:object/:mode/:checklistType', component: TaskListComponent },

      { path: 'currentoverviewstatus', component: CurrentOverviewStatusComponent }
    ]
  },
  { path: '**', redirectTo: '/home' }
];